export const steps = [
  {
    title: 'Téléchargez',
    description: 'Recevez instantanément Le Jazz Master et les 5 bonus exclusifs dans votre boîte mail.',
  },
  {
    title: 'Imprimez',
    description: 'Imprimez le cours de la semaine en deux minutes. Tout est déjà mis en page.',
  },
  {
    title: 'Enseignez',
    description: 'Suivez le plan, donnez la fiche de devoirs, et regardez vos élèves progresser.',
  },
];
